import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

import PostConfig from './PostConfig';
import AppSection from './configs/AppSection';
import AppDataSource from './configs/AppDataSource';
import ReusableComponent from './configs/ReusableComponent';

export const GET_PAGE_LAYOUT = gql`
  query getPageLayout($layout: String!) {
    getPageLayout(layout: $layout) {
      layout
      template
      isAContainer
      type
    }
  }
`;

const APP = 'app';
const DATA_SOURCE = 'appDataSource';
const COMPONENT = 'component';

const Config = ({ currentPost, addStatusMessage, closeModal, updatePost }) => {
  const { layout } = useParams();

  const { data, loading } = useQuery(GET_PAGE_LAYOUT, { variables: { layout }, skip: currentPost || !layout });

  if (loading || (!data && !currentPost)) return null;

  const { getPageLayout } = data || {};

  const isEdit = !!currentPost;

  const post = currentPost || getPageLayout?.template;

  // TODO: chage this to a switch
  const isAppSection = post.type === APP;
  const isDataSource = post.type === DATA_SOURCE;
  const isReusableComponent = post.type === COMPONENT;

  if (isAppSection) return <AppSection {...{ closeModal, addStatusMessage, post, isEdit }} />;
  if (isDataSource) return <AppDataSource {...{ closeModal, addStatusMessage, post, isEdit }} />;
  if (isReusableComponent) return <ReusableComponent {...{ closeModal, addStatusMessage, post, isEdit, updatePost }} />;
  return <PostConfig {...{ closeModal, addStatusMessage, post, isEdit, updatePost }} />;
};

Config.propTypes = {
  currentPost: PropTypes.shape({}),
  addStatusMessage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  updatePost: PropTypes.func.isRequired,
};

Config.defaultProps = {
  currentPost: null,
};

export default Config;
